import React, { Component } from "react";
import { connect } from "react-redux";
import Breadcrumb from "../common/breadcrumb";
import {
  getValueFromLanguageObject,
  loadUserDetailsFromLocalStorage,
} from "../../store";
import { getCall } from "../../api/post";
import { getOrderPdfurl } from "../../services";
import { getMasterDetailsId } from "../../actions";
import { withRouter } from "react-router-dom";

class Downloads extends Component {
  state = {
    orders: [],
    loading: true,
    error: null,
    showPdfViewer: false,
    pdfUrl: "",
    loadingPdf: false,
    pdfObjectUrl: null,
  };

  async componentDidMount() {
    try {
      const userDetails = loadUserDetailsFromLocalStorage();
      if (!userDetails || !userDetails.id) {
        this.setState({ error: "User not found", loading: false });
        return;
      }

      const ordersData = await getCall(
        `v2/orders?where[userId]=${encodeURIComponent(userDetails.id)}`
      );

      if (
        ordersData &&
        ordersData.responseStatus === 200 &&
        Array.isArray(ordersData.data)
      ) {
        this.setState({ orders: ordersData.data, loading: false });
      } else {
        this.setState({ error: "Failed to fetch orders", loading: false });
      }
    } catch (err) {
      this.setState({ error: "Failed to fetch orders", loading: false });
    }

    if (this.props.initMasterDetailsId) {
      this.props.initMasterDetailsId();
    }
  }

  handleDownload = (media) => {
    this.setState({ error: null });
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!userDetails || (!userDetails.id && !userDetails.apitoken && !localStorage.getItem('apiToken'))) {
      this.setState({ error: "You must be logged in to view this file." });
      return;
    }

    const url = getOrderPdfurl(media.original_name, this.props.masterDetailsObj);
    if (!url) {
      this.setState({ error: "Invalid file URL." });
      return;
    }

    // Fetch the PDF with Authorization header and create an object URL
    (async () => {
      try {
        this.setState({ loadingPdf: true });
        const apiToken = localStorage.getItem('apiToken') || userDetails.apitoken || userDetails.token || userDetails.access_token;
        const headers = apiToken ? { Authorization: `Bearer ${apiToken}` } : {};
        const res = await fetch(url, { method: 'GET', headers, credentials: 'include' });
        if (!res.ok) {
          const msg = `Failed to download file (${res.status})`;
          this.setState({ error: msg, loadingPdf: false });
          return;
        }
        const blob = await res.blob();
        const objectUrl = URL.createObjectURL(blob);
        // Revoke previous object URL if present
        if (this.state.pdfObjectUrl) {
          try { URL.revokeObjectURL(this.state.pdfObjectUrl); } catch (e) {}
        }
        this.setState({ pdfUrl: objectUrl, pdfObjectUrl: objectUrl, showPdfViewer: true, loadingPdf: false });
      } catch (err) {
        this.setState({ error: 'Failed to fetch file', loadingPdf: false });
      }
    })();
  };

  render() {
    const { orders, loading, error, showPdfViewer, pdfUrl } = this.state;

    const filteredOrders = orders.filter(
      (order) => Array.isArray(order.ordermedias) && order.ordermedias.length > 0
    );

    return (
      <div>
        <Breadcrumb
          title={getValueFromLanguageObject("str_downloads") || "Downloads"}
        />

        <section className="section-b-space">
          <div className="container px-4">
            <div className="row justify-content-center">
              <div className="col-12">
                <div
                  className="card shadow-sm border-0"
                  style={{ borderRadius: "10px" }}
                >
                  <div className="card-body p-4">
                    <h4 className="mb-4" style={{ fontWeight: 600, color: "#333" }}>
                      {getValueFromLanguageObject("str_downloads") || "Downloads"}
                    </h4>

                    {loading ? (
                      <div className="text-center py-5">Loading...</div>
                    ) : error ? (
                      <div className="text-center py-5 text-danger">{error}</div>
                    ) : filteredOrders.length === 0 ? (
                      <div className="text-center py-5 text-muted">
                        {getValueFromLanguageObject("str_no_downloads") ||
                          "No downloads available."}
                      </div>
                    ) : (
                      <table
                        className="table table-hover"
                        style={{
                          width: "100%",
                          background: "#fff",
                          borderRadius: "8px",
                          overflow: "hidden",
                          fontSize: "14px",
                          tableLayout: "auto",
                          marginBottom: 0,
                        }}
                      >
                        <thead className="thead-light">
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontWeight: 500,
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              {getValueFromLanguageObject("str_order_id") || "Order ID"}
                            </th>
                            <th
                              style={{
                                width: "55%",
                                fontWeight: 500,
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              {getValueFromLanguageObject("str_order_items") ||
                                "Order Media"}
                            </th>
                            <th
                              style={{
                                width: "25%",
                                fontWeight: 500,
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredOrders.map((order) => (
                            <tr key={order.id}>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  fontWeight: 500,
                                  textAlign: "left",
                                }}
                              >
                                {order.orderno}
                              </td>
                              <td>
                                {order.ordermedias.map((media, idx) => (
                                  <div
                                    key={media.id || idx}
                                    style={{
                                      marginBottom: "6px",
                                      fontSize: "14px",
                                      color: "#222",
                                      fontWeight: 400,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-file"
                                      style={{ color: "#FF6A00", fontSize: "14px" }}
                                    />
                                    <span>{media.display_name || media.original_name}</span>
                                  </div>
                                ))}
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                    alignItems: "center",
                                  }}
                                >
                                  {order.ordermedias.map((media, idx) => (
                                    <button
                                      key={media.id || idx}
                                      className="btn btn-sm"
                                      style={{
                                        background: "#FF6A00",
                                        color: "#fff",
                                        fontWeight: 500,
                                        borderRadius: "6px",
                                        minWidth: "100px",
                                        maxWidth: "140px",
                                        fontSize: "13px",
                                        boxShadow: "0 2px 8px rgba(255,167,38,0.08)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                        padding: "4px 10px",
                                      }}
                                      onClick={() => this.handleDownload(media)}
                                    >
                                      <i className="fa fa-download" />
                                    </button>
                                  ))}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= PDF MODAL ================= */}
        {showPdfViewer && (
          <div
            className="pdf-modal"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
            onClick={() => this.setState({ showPdfViewer: false })}
          >
            <div
              style={{
                width: "80%",
                height: "80%",
                background: "#fff",
                borderRadius: "10px",
                overflow: "hidden",
                position: "relative",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  zIndex: 10,
                  border: "none",
                  background: "transparent",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  // Revoke object URL when closing modal
                  if (this.state.pdfObjectUrl) {
                    try { URL.revokeObjectURL(this.state.pdfObjectUrl); } catch (e) {}
                  }
                  this.setState({ showPdfViewer: false, pdfUrl: '', pdfObjectUrl: null });
                }}
              >
                &times;
              </button>

              {this.state.loadingPdf ? (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Loading file...
                </div>
              ) : (
                <iframe
                  src={pdfUrl}
                  title="PDF Viewer"
                  style={{ width: "100%", height: "100%", border: "none" }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  masterDetailsObj: state.masterDetails.masterDetailsObj,
});

export default connect(mapStateToProps, {
  initMasterDetailsId: getMasterDetailsId,
})(withRouter(Downloads));
